import { render, staticRenderFns } from "./add_oldPosition.vue?vue&type=template&id=26077277&scoped=true&"
import script from "./add_oldPosition.vue?vue&type=script&lang=js&"
export * from "./add_oldPosition.vue?vue&type=script&lang=js&"
import style0 from "./add_oldPosition.vue?vue&type=style&index=0&id=26077277&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26077277",
  null
  
)

export default component.exports